export const defaultPassengers = 2;
export const oneWayTripDefaultNights = 2;
